// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import {
  Radio,
  RadioGroup,
  FormHelperText,
  RadioGroupProps,
  FormControlLabel,
} from '@mui/material';

// ----------------------------------------------------------------------

interface IProps {
  name: string;
  options: string[] | boolean[];
  getOptionLabel?: string[];
  onClick?: () => void;
  disabled?: boolean;
}

export default function RHFRadioGroupProduct({
  name,
  options,
  getOptionLabel,
  onClick,
  disabled,
  ...other
}: IProps & RadioGroupProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <RadioGroup {...field} row {...other}>
            {options.map((option, index) => (
              <FormControlLabel
                key={`${option}_${name}`}
                value={option}
                control={<Radio onClick={onClick} />}
                label={getOptionLabel?.length ? getOptionLabel[index] : option}
                disabled={disabled || option === "giftback" || field.value === "giftback"} 
              />
            ))}
          </RadioGroup>

          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
